"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncateClassName = exports.overflowClassName = exports.cellStaticClassName = exports.Cell = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Cell.css");
var _useCellSpacing = require("@cbhq/cds-common/hooks/useCellSpacing");
var _cell = require("@cbhq/cds-common/utils/cell");
var _useOffsetStyles = require("../hooks/useOffsetStyles");
var _useResponsiveCellSpacing = require("../hooks/useResponsiveCellSpacing");
var _Box = require("../layout/Box");
var _HStack = require("../layout/HStack");
var _focus = require("../styles/focus");
var _responsive = require("../styles/responsive");
var _Pressable = require("../system/Pressable");
var _linaria = require("../utils/linaria");
const _excluded = ["accessory", "as", "alignItems", "borderRadius", "children", "detail", "detailWidth", "disabled", "gap", "intermediary", "media", "minHeight", "maxHeight", "onPress", "onKeyDown", "onKeyPress", "priority", "selected", "testID", "to", "target", "href", "tabIndex", "shouldOverflow", "responsiveConfig", "accessibilityLabel", "accessibilityLabelledBy", "accessibilityHint"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const pressClassName = "cds-pressClassName-p11oqeu5";
const cellStaticClassName = 'cds-cell';
exports.cellStaticClassName = cellStaticClassName;
const baseStyles = "cds-baseStyles-b11jkhgs";

// Display and min-width are necessary for truncation to work:
// https://css-tricks.com/flexbox-truncated-text/
const truncate = "cds-truncate-turtz9p";
const overflow = "cds-overflow-o1f3fdvg";
const overflowClassName = (0, _linaria.cx)(cellStaticClassName, overflow);
exports.overflowClassName = overflowClassName;
const truncateClassName = (0, _linaria.cx)(cellStaticClassName, truncate);
exports.truncateClassName = truncateClassName;
const Cell = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function Cell(_ref, ref) {
  var _ref2, _ref3, _ref4;
  let accessory = _ref.accessory,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    _ref$alignItems = _ref.alignItems,
    alignItems = _ref$alignItems === void 0 ? 'center' : _ref$alignItems,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? 'rounded' : _ref$borderRadius,
    children = _ref.children,
    detail = _ref.detail,
    detailWidth = _ref.detailWidth,
    disabled = _ref.disabled,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 2 : _ref$gap,
    intermediary = _ref.intermediary,
    media = _ref.media,
    minHeight = _ref.minHeight,
    maxHeight = _ref.maxHeight,
    onPress = _ref.onPress,
    onKeyDown = _ref.onKeyDown,
    onKeyPress = _ref.onKeyPress,
    priority = _ref.priority,
    selected = _ref.selected,
    testID = _ref.testID,
    to = _ref.to,
    target = _ref.target,
    href = _ref.href,
    tabIndex = _ref.tabIndex,
    shouldOverflow = _ref.shouldOverflow,
    responsiveConfig = _ref.responsiveConfig,
    accessibilityLabel = _ref.accessibilityLabel,
    accessibilityLabelledBy = _ref.accessibilityLabelledBy,
    accessibilityHint = _ref.accessibilityHint,
    spacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const spacing = (0, _useCellSpacing.useCellSpacing)(spacingProps);
  const offsetClassName = (0, _useOffsetStyles.useOffsetStyles)({
    offsetHorizontal: spacing.inner.offsetHorizontal
  });
  const _useResponsiveCellSpa = (0, _useResponsiveCellSpacing.useResponsiveCellSpacingStyles)(responsiveConfig),
    responsiveInnerSpacing = _useResponsiveCellSpa.responsiveInnerSpacing,
    responsiveOuterSpacing = _useResponsiveCellSpa.responsiveOuterSpacing;
  const linkable = Boolean((_ref2 = (_ref3 = (_ref4 = onPress !== null && onPress !== void 0 ? onPress : onKeyDown) !== null && _ref4 !== void 0 ? _ref4 : onKeyPress) !== null && _ref3 !== void 0 ? _ref3 : to) !== null && _ref2 !== void 0 ? _ref2 : href);
  const maybeTruncateClassName = (0, _linaria.cx)(cellStaticClassName, baseStyles, !shouldOverflow && truncateClassName);
  let content = /*#__PURE__*/_react.default.createElement(_HStack.HStack, _extends({
    alignItems: alignItems,
    background: selected ? 'backgroundAlternate' : undefined,
    borderRadius: borderRadius,
    flexGrow: 1,
    gap: gap,
    testID: testID,
    width: "100%"
  }, spacing.inner, {
    className: (0, _linaria.cx)(responsiveInnerSpacing, responsiveConfig && _responsive.responsiveClassName),
    offsetHorizontal: linkable ? undefined : spacing.inner.offsetHorizontal
  }), media && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    flexGrow: 0,
    flexShrink: 0
  }, media), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    className: maybeTruncateClassName,
    flexGrow: 1,
    flexShrink: (0, _cell.hasCellPriority)('start', priority) ? 0 : 1,
    justifyContent: "flex-start"
  }, children), !!intermediary && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    className: maybeTruncateClassName,
    flexGrow: 0,
    flexShrink: (0, _cell.hasCellPriority)('middle', priority) ? 0 : 1,
    justifyContent: "center"
  }, intermediary), !!detail && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    alignItems: "flex-end",
    className: maybeTruncateClassName,
    flexDirection: "column",
    flexGrow: detailWidth ? undefined : 1,
    flexShrink:
    // eslint-disable-next-line no-nested-ternary
    detailWidth ? undefined : (0, _cell.hasCellPriority)('end', priority) ? 0 : 1,
    justifyContent: "flex-end",
    width: detailWidth
  }, detail), !!accessory && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    flexGrow: 0,
    flexShrink: 0
  }, accessory));
  if (linkable) {
    content = /*#__PURE__*/_react.default.createElement(_Pressable.Pressable, {
      noScaleOnPress: true,
      transparentWhileInactive: true,
      accessibilityHint: accessibilityHint,
      accessibilityLabel: accessibilityLabel,
      accessibilityLabelledBy: accessibilityLabelledBy,
      background: "background",
      borderRadius: borderRadius,
      className: (0, _linaria.cx)(pressClassName, offsetClassName, _focus.insetFocusRing),
      disabled: disabled,
      href: href,
      onKeyDown: onKeyDown,
      onKeyPress: onKeyPress,
      onPress: onPress,
      tabIndex: tabIndex,
      target: target,
      testID: testID && `${testID}-cell-pressable`,
      to: to
    }, content);
  }
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    alignItems: "stretch",
    as: as,
    maxHeight: maxHeight,
    minHeight: minHeight,
    width: "100%"
  }, spacing.outer, {
    ref: ref,
    className: (0, _linaria.cx)(responsiveOuterSpacing, responsiveConfig && _responsive.responsiveClassName)
  }), content);
}));
exports.Cell = Cell;